export default function ({ store, redirect, app }) {
  redirect(app.localePath('/'))
}
